import { GlobalConfig } from ".";
import { getAuthContext } from "./getAutContext";
let Context;
export function init(config) {
    if (!Object.isFrozen(GlobalConfig)) {
        GlobalConfig.config = Object.assign(Object.assign({}, GlobalConfig.config), config);
        Object.freeze(GlobalConfig);
        if (!Object.isFrozen(Context) || Context === undefined) {
            Context = getAuthContext(GlobalConfig.config);
            Context.Subscriptions.forEach(x => x.subscribe());
            Context.Gateway.init();
            Object.freeze(Context);
        }
    }
    else {
        console.warn("Already initialized");
    }
}
export function getToken() {
    if (!Object.isFrozen(GlobalConfig) || Context === undefined) {
        throw new Error("sb-authorization-lib is not initialized");
    }
    return Context.Gateway.getToken();
}
;
export function getPlatformJwtManager() {
    if (!Object.isFrozen(GlobalConfig) || Context === undefined) {
        throw new Error("sb-authorization-lib is not initialized");
    }
    return Context.PlatformJwtManager;
}
;
export function getExtSessionId() {
    if (!Object.isFrozen(GlobalConfig) || Context === undefined) {
        throw new Error("sb-authorization-lib is not initialized");
    }
    return Context.Gateway.getExtSessionId();
}
;
const standardLogin = (params) => {
    if (!Object.isFrozen(GlobalConfig) || Context === undefined) {
        throw new Error("sb-authorization-lib is not initialized");
    }
    if (Context.PlatformGateway === undefined) {
        throw new Error("PlatformGateway is not initialized");
    }
    return Context.PlatformGateway.login(params);
};
const rememberMeLogin = (params) => {
    if (!Object.isFrozen(GlobalConfig) || Context === undefined) {
        throw new Error("sb-authorization-lib is not initialized");
    }
    if (Context.PlatformGateway === undefined) {
        throw new Error("PlatformGateway is not initialized");
    }
    return Context.PlatformGateway.rememberMeLogin(params);
};
const danishLogin = (params) => {
    if (!Object.isFrozen(GlobalConfig) || Context === undefined) {
        throw new Error("sb-authorization-lib is not initialized");
    }
    if (Context.PlatformGateway === undefined) {
        throw new Error("PlatformGateway is not initialized");
    }
    return Context.PlatformGateway.danishLogin(params);
};
export const platformAuthClient = { standardLogin, rememberMeLogin, danishLogin };
//# sourceMappingURL=init.js.map